import routes from "@/routes/routes";
import type { RouteConfig } from "@/types/routestypes";

export const getPageTitle = (pathname: string) => {
  const normalizePath = (value: string) => value.replace(/\/+$/, "") || "/";

  const buildPath = (parentPath: string, currentPath: string) => {
    if (currentPath.startsWith("/")) {
      return normalizePath(currentPath);
    }

    return normalizePath(`${parentPath}/${currentPath}`);
  };

  const flattenRoutes = (
    routeEntries: Record<string, RouteConfig> | RouteConfig[],
    parentPath = "",
  ): Array<{ path: string; pageName?: string }> => {
    const routeList = Array.isArray(routeEntries)
      ? routeEntries
      : Object.values(routeEntries);

    return routeList.flatMap((route) => {
      const currentPath = buildPath(parentPath, route.path);
      const ownEntry = route.pageName
        ? [{ path: currentPath, pageName: route.pageName }]
        : [];
      const childEntries = route.children
        ? flattenRoutes(route.children, currentPath)
        : [];

      return [...ownEntry, ...childEntries];
    });
  };

  const removeLastEndpoint = (value: string) =>
    normalizePath(value).split("/").slice(0, -1).join("/") || "/";

  const route = flattenRoutes(routes.privateRoutes).find((currentRoute) => {
    const routePath = normalizePath(currentRoute.path);
    const currentPath = normalizePath(pathname);

    return (
      routePath === currentPath ||
      (routePath.endsWith("Id") &&
        removeLastEndpoint(routePath) === removeLastEndpoint(currentPath))
    );
  });

  return route?.pageName || "";
};
